import { ActionTypes } from '../constants'

const session = (state = {
  user: null,
  verificating: true,
  fetching: false,
  error: null,
  updatedOn: null
}, action) => {
  switch (action.type) {
  case ActionTypes.REGISTER_TEACHER_SUCCESS:
  case ActionTypes.REGISTER_PARENT_SUCCESS:
  case ActionTypes.UPDATE_PROFILE_SUCCESS:
  case ActionTypes.PARTICIPATE_SUCCESS:
  case ActionTypes.FINISH_OLYMPIAD_SUCCESS:
  case ActionTypes.RESTART_OLYMPIAD_SUCCESS:
    return { ...state, user: action.user, updatedOn: new Date() }

  case ActionTypes.VERIFICATION_REQUEST:
    return { ...state, verificating: true }

  case ActionTypes.VERIFICATION_SUCCESS:
    return {
      ...state,
      verificating: false,
      user: action.user,
      updatedOn: new Date()
    }

  case ActionTypes.VERIFICATION_FAILURE: {
    const response = action.error && action.error.response
    const status = response && response.status

    // Do not clear the user on network errors (no response or no status)
    if (!response || !status) {
      return { ...state, verificating: false, error: action.error }
    }

    // Clear user only for explicit auth failures
    if (status === 401 || status === 403) {
      return { ...state, verificating: false, user: null }
    }

    // Keep user for other server-side errors (e.g., 5xx)
    return { ...state, verificating: false, error: action.error }
  }

  case ActionTypes.LOGOUT_SUCCESS:
    return { ...state, user: null, verificating: false, updatedOn: null }

  case ActionTypes.LOGIN_REQUEST:
    return { ...state, fetching: true, error: null }

  case ActionTypes.LOGIN_SUCCESS:
    return {
      ...state,
      user: action.user,
      fetching: false,
      error: null,
      updatedOn: new Date()
    }

  case ActionTypes.LOGIN_FAILURE:
    return {
      ...state,
      fetching: false,
      error: action.error
    }

  default:
    return state
  }
}

export default session
